import { Bot, Sparkles, X } from "lucide-react";
import { useChatSidebarStrict } from "@/contexts/ChatSidebarContext";

export function ChatSidebar() {
  const { isOpen, close } = useChatSidebarStrict();

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={close}
          aria-hidden="true"
        />
      )}

      {/* Chat Sidebar */}
      <div
        className={`
          fixed top-0 right-0 h-full w-full md:w-96 bg-sidebar border-l border-white/10
          transform transition-transform duration-300 ease-in-out z-50
          flex flex-col
          ${isOpen ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-teal-400 to-green-300 flex items-center justify-center">
              <Bot className="w-6 h-6 text-gray-900" />
            </div>
            <div>
              <h2 className="text-white font-semibold">AI Assistant</h2>
              <p className="text-white/50 text-xs">Coming soon</p>
            </div>
          </div>
          <button
            onClick={close}
            className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
            aria-label="Close chat"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>

        {/* Coming soon placeholder */}
        <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-teal-400 to-green-300 flex items-center justify-center mb-6">
            <Sparkles className="w-10 h-10 text-gray-900" />
          </div>
          <h3 className="text-white text-xl font-semibold mb-2">Coming soon</h3>
          <p className="text-white/60 text-sm max-w-xs leading-relaxed">
            Our AI Assistant is on the way. It will help you navigate your programme, answer
            questions, and guide your learning — stay tuned.
          </p>
        </div>
      </div>
    </>
  );
}
